function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import Button from '../Button';
import { classNamesFor } from '../utils/classNames';
import AlignToText from '../AlignToText';
var cx;
/**
 * The CollapsableSection component provides a simple container which can be opened or
 * closed to reveal more content
 *
 * ## Composed of
 * - [Button](../Button/README.md)
 *
 * ## Related Components
 * - [DropdownMenu](../DropdownMenu/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <CollapsableSection
 *    label="My Section"
 *    onOpen={() => console.log('open section')}
 *    onClose={() => console.log('close section')}
 *    isOpen
 * >
 *   Some content that can be hidden from view with a click of a button or keypress
 * </CollapsableSection>
 * ```
 *
 * ## Props
 */

var CollapsableSection = /*#__PURE__*/function (_PureComponent) {
  _inherits(CollapsableSection, _PureComponent);

  var _super = _createSuper(CollapsableSection);

  function CollapsableSection() {
    var _this;

    _classCallCheck(this, CollapsableSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "_handleKeyDown", function (event) {
      var keyCode = event.keyCode;
      var isArrowDown = keyCode === 40;
      var isArrowUp = keyCode === 38;

      if (isArrowUp || isArrowDown) {
        _this._open();

        event.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_open", function () {
      var onOpen = _this.props.onOpen;

      if (!_this._hasIsOpenProp()) {
        _this.setState({
          isOpen: true
        });
      }

      onOpen();
    });

    _defineProperty(_assertThisInitialized(_this), "_close", function () {
      var onClose = _this.props.onClose;

      if (!_this._hasIsOpenProp()) {
        _this.setState({
          isOpen: false
        });
      }

      onClose();
    });

    _defineProperty(_assertThisInitialized(_this), "_toggleOpen", function () {
      if (_this._isOpen()) {
        _this._close();
      } else {
        _this._open();
      }
    });

    return _this;
  }

  _createClass(CollapsableSection, [{
    key: "_isOpen",
    value: function _isOpen() {
      var isOpen = this.props.isOpen;
      var isOpenInternal = this.state.isOpen;
      return this._hasIsOpenProp() ? isOpen : isOpenInternal;
    }
  }, {
    key: "_hasIsOpenProp",
    value: function _hasIsOpenProp() {
      var isOpen = this.props.isOpen;
      return typeof isOpen === 'boolean';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          header = _this$props.header,
          label = _this$props.label,
          className = _this$props.className,
          disabled = _this$props.disabled,
          variant = _this$props.variant,
          children = _this$props.children,
          telemetryMeta = _this$props.telemetryMeta,
          trackClick = _this$props.trackClick;

      var isOpen = this._isOpen();

      var _CollapsableSection$g = CollapsableSection.getClassName({
        className: className,
        variant: variant,
        isOpen: isOpen,
        disabled: disabled
      }),
          root = _CollapsableSection$g.root,
          trigger = _CollapsableSection$g.trigger,
          triggerIcon = _CollapsableSection$g.triggerIcon,
          titleClass = _CollapsableSection$g.title,
          optionsClass = _CollapsableSection$g.options;

      return /*#__PURE__*/React.createElement("div", {
        "data-qa": qa,
        className: root
      }, /*#__PURE__*/React.createElement("header", {
        className: "psw-m-b-3"
      }, /*#__PURE__*/React.createElement(Button, {
        qa: "".concat(qa, "#sectionTrigger"),
        ariaExpanded: isOpen,
        className: trigger,
        telemetryMeta: telemetryMeta,
        trackClick: trackClick,
        variant: "content",
        onKeyDown: this._handleKeyDown,
        onClick: this._toggleOpen,
        disabled: disabled
      }, header && typeof header === 'function' ? header(isOpen) : header, !header && /*#__PURE__*/React.createElement("span", {
        "data-qa": "".concat(qa, "#sort-by"),
        className: titleClass
      }, label), /*#__PURE__*/React.createElement(AlignToText, {
        fontStyle: "title-s",
        className: "psw-icon-container",
        spacer: /*#__PURE__*/React.createElement("div", {
          className: "psw-l-w-icon-3"
        })
      }, /*#__PURE__*/React.createElement(Icon, {
        className: triggerIcon,
        type: "chevron-down",
        size: "3"
      })))), /*#__PURE__*/React.createElement("div", {
        "data-qa": "".concat(qa, "#sectionContent"),
        className: optionsClass
      }, children));
    }
  }]);

  return CollapsableSection;
}(PureComponent);

CollapsableSection.getClassName = function (_ref) {
  var className = _ref.className,
      variant = _ref.variant,
      isOpen = _ref.isOpen,
      disabled = _ref.disabled;
  return {
    root: cx('psw-collapsable-section', _defineProperty({}, "psw-".concat(variant, "-collapsable-section"), variant), _defineProperty({}, cx('psw-is-disabled', 'psw-c-secondary'), disabled), {
      'psw-is-open': isOpen
    }, className),
    title: cx('psw-t-title-s', 'psw-c-t-1'),
    trigger: cx('psw-collapsable-section-trigger', 'psw-ally-indicator', 'psw-ally-indicator-gap-1', 'psw-c-bg-interactive-2', 'psw-l-line-repel', 'psw-fill-x', 'psw-p-4', 'psw-r-1'),
    triggerIcon: cx('psw-collapsable-section-icon', 'psw-m-l-4'),
    options: cx({
      'psw-sr-only': !isOpen
    }, {
      'psw-hide': disabled
    })
  };
};

CollapsableSection.useClassNames = function (x) {
  CollapsableSection.classNames = x;
};

CollapsableSection.defaultProps = {
  qa: '',
  className: '',
  label: '',
  header: null,
  variant: '',
  disabled: false,
  isOpen: null,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  telemetryMeta: null,
  trackClick: null,
  children: null
};
CollapsableSection.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Whether of not the dropdown menu should be open
   */
  isOpen: PropTypes.bool,

  /**
   * Whether or not to show custom header
   */
  header: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  /**
   * The section label / heading
   */
  label: PropTypes.string,

  /**
   * Presentational variant
   */
  variant: PropTypes.string,

  /**
   * MenuGroup or MenuOptions to show within the dropdown
   */
  children: PropTypes.node,

  /**
   * Whether or not the dropdown can be opened and selected
   */
  disabled: PropTypes.bool,

  /**
   * event callback called when the options should be shown
   */
  onOpen: PropTypes.func,

  /**
   * event callback called when the options should be closed
   */
  onClose: PropTypes.func,

  /**
   * Serialized json data of context specific telemetry data
   */
  telemetryMeta: PropTypes.string,

  /**
   * The spec id identifying the interaction
   */
  trackClick: PropTypes.string
};
cx = classNamesFor(CollapsableSection);
export default CollapsableSection;